import { isNumeric } from './assertion.esm.js';

var toPx = function toPx(v) {
  var value = typeof v === 'string' && isNumeric(v) ? parseFloat("".concat(v)) : +v;
  var unit = typeof v === 'string' ? v.replace(/^([0-9]+\.?[0-9]*|\.[0-9]+)/g, '') : 'px';
  return unit === 'px' ? value : unit === 'rem' || unit === 'em' ? value * 16 : value;
};

export default toPx;
//# sourceMappingURL=to-px.esm.js.map
